function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelegate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.05925 2.5C3.05925 2.08579 3.39504 1.75 3.80925 1.75H13.3092C14.8285 1.75 16.0592 2.98079 16.0592 4.5V14C16.0592 14.4142 15.7235 14.75 15.3092 14.75C14.895 14.75 14.5592 14.4142 14.5592 14V4.5C14.5592 3.80921 14 3.25 13.3092 3.25H3.80925C3.39504 3.25 3.05925 2.91421 3.05925 2.5Z",
    fill: "#F1F0F3",
    style: {
      fill: "#F1F0F3",
      fill: "color(display-p3 0.9451 0.9412 0.9529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.04926 7.5C4.04926 7.08579 4.38504 6.75 4.79926 6.75H10.3093C10.7235 6.75 11.0593 7.08579 11.0593 7.5V13.01C11.0593 13.4242 10.7235 13.76 10.3093 13.76C9.89504 13.76 9.55926 13.4242 9.55926 13.01V8.25H4.79926C4.38504 8.25 4.04926 7.91421 4.04926 7.5Z",
    fill: "#F1F0F3",
    style: {
      fill: "#F1F0F3",
      fill: "color(display-p3 0.9451 0.9412 0.9529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8396 6.96967C11.1325 7.26256 11.1325 7.73744 10.8396 8.03033L3.3396 15.5303C3.0467 15.8232 2.57183 15.8232 2.27894 15.5303C1.98604 15.2374 1.98604 14.7626 2.27894 14.4697L9.77893 6.96967C10.0718 6.67678 10.5467 6.67678 10.8396 6.96967Z",
    fill: "#F1F0F3",
    style: {
      fill: "#F1F0F3",
      fill: "color(display-p3 0.9451 0.9412 0.9529)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelegate);
export default __webpack_public_path__ + "static/media/Delegate.13c421219104df8ca32bbb903e70266b.svg";
export { ForwardRef as ReactComponent };